<template>
  <div>
    <data-table :service="service"
                :entity="entity"
                :columns="columns"
                :filters="filters"
                :disable-permission-checks="true"
                ref="table">
      <template v-slot:given_name="{row}">
        {{row.given_name}} {{row.family_name}}
      </template>
      <template v-slot:stats="{row}">
        <el-tooltip :content="$t('candidates.job_alerts.count')" placement="top" :open-delay="300">
          <div class="flex items-center justify-center mr-2">
            <bell-icon class="stats-icon"></bell-icon>
            <span class="stats-text">{{row.job_alerts.length}}</span>
          </div>
        </el-tooltip>
        <el-tooltip :content="$t('candidates.favorites.count')" placement="top" :open-delay="300">
          <div class="flex items-center justify-center mr-2">
            <star-icon class="stats-icon"></star-icon>
            <span class="stats-text">{{row.favourites.length}}</span>
          </div>
        </el-tooltip>
        <el-tooltip :content="$t('candidates.resumes.count')" placement="top" :open-delay="300">
          <div class="flex items-center justify-center">
            <file-text-icon class="stats-icon"></file-text-icon>
            <span class="stats-text">{{row.resumes.length}}</span>
          </div>
        </el-tooltip>

      </template>
      <template v-slot:created_at="{row}">
        {{$formatDate(row.created_at, FRIENDLY_DATETIME_FORMAT)}}
      </template>
      <template v-slot:updated_at="{row}">
        {{$formatDate(row.updated_at, FRIENDLY_DATETIME_FORMAT)}}
      </template>
    </data-table>
  </div>
</template>
<script>
  import entities from 'src/config/entities'
  import CandidateService from 'src/services/CandidateService'
  import { BellIcon, StarIcon, FileTextIcon } from 'vue-feather-icons'
  import { FRIENDLY_DATETIME_FORMAT } from 'src/config/dateUtils'

  export default {
    components: {
      BellIcon,
      StarIcon,
      FileTextIcon
    },
    data () {
      return {
        FRIENDLY_DATETIME_FORMAT,
        service: CandidateService,
        entity: entities.CANDIDATE
      }
    },
    computed: {
      columns () {
        return [
          {
            prop: 'given_name',
            label: this.$t('candidates.list.name'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'email',
            label: this.$t('candidates.list.email'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'created_at',
            label: this.$t('generic.createdAt'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'updated_at',
            label: this.$t('candidates.list.updated_at'),
            minWidth: '150px',
            sortable: true
          },
          {
            prop: 'stats',
            label: this.$t('candidates.list.stats'),
            minWidth: '150px',
            sortable: true
          },
        ]
      },
      filters () {
        return [
          {
            key: 'sort',
            value: '+created_at'
          },
          {
            key: 'with',
            value: 'favourites,user,job_alerts,resumes'
          }
        ]
      }
    }
  }
</script>
